/**
 * investigation service
 */

import { createAxiosServiceInstance } from '../api';
import Axios_lib from 'axios';
import { apiConfig } from '../apiConfig';

const axios = createAxiosServiceInstance();
const baseUrl = `${apiConfig.serviceApi}/ns/iad/onDemandScreening/alerts`;
const filterBaseUrl = `${apiConfig.serviceApi}`;

let source;

/**
 * Fetch watchlist filter options from the API.
 * Used by useWatchlistOptions hook for filter dropdowns.
 *
 * @param {string} endpoint - API endpoint path (e.g., '/ns/iad/onDemandScreening/filters/watchlist-category')
 * @param {Object} params - Query parameters
 * @param {number} params.offset - Pagination offset
 * @param {number} params.limit - Number of items to return
 * @param {string} params.search - Search term for typeahead
 * @param {string} params.sourceIds - Comma-separated source IDs
 * @param {Object} options - Axios options (e.g., signal for AbortController)
 * @returns {Promise<{payload: string[], total: number}>}
 */
export async function fetchWatchlistFilterOptions(endpoint, params, options = {}) {
  const { offset = 0, limit = 100, search, sourceIds = '27,28' } = params;

  const queryParams = {
    offset,
    limit,
    sourceIds
  };

  if (search) {
    queryParams.search = search;
  }

  const response = await axios.get(`${filterBaseUrl}${endpoint}`, {
    params: queryParams,
    ...options
  });

  return response.data;
}
export async function getInvestListData(payload) {
  if (source) {
    source.cancel();
  }
  const CancelToken = Axios_lib.CancelToken;
  source = CancelToken.source();

  const {
    limit,
    offset,
    sourceIds,
    // Existing filter params
    scoreLow,
    scoreHigh,
    isSentToCm,
    partySearch,
    // New watchlist filter params (FIN-6612)
    watchlistCategory,
    watchlistSubCategory,
    watchlistKeyword,
    externalSource,
    watchlistSource,
    isWhitelisted,
    // New search params (FIN-6612)
    searchField,
    searchText,
    ...restPayload
  } = payload;

  let params = {
    ...restPayload,
    limit: limit || 20,
    offset: offset || 0,
    sourceIds: sourceIds || '27,28'
  };

  // Add existing filter params if present
  if (scoreLow !== undefined) params.scoreLow = scoreLow;
  if (scoreHigh !== undefined) params.scoreHigh = scoreHigh;
  if (isSentToCm !== undefined) params.isSentToCm = isSentToCm;
  if (partySearch) params.partySearch = partySearch;

  // Add new watchlist filter params (FIN-6612)
  if (watchlistCategory?.length > 0) {
    params.watchlistCategory = watchlistCategory.join(',');
  }
  if (watchlistSubCategory?.length > 0) {
    params.watchlistSubCategory = watchlistSubCategory.join(',');
  }
  if (watchlistKeyword?.length > 0) {
    params.watchlistKeyword = watchlistKeyword.join(',');
  }
  if (externalSource?.length > 0) {
    params.externalSource = externalSource.join(',');
  }
  if (watchlistSource?.length > 0) {
    params.watchlistSource = watchlistSource.join(',');
  }
  if (isWhitelisted !== undefined) {
    params.isWhitelisted = isWhitelisted;
  }

  // Add new search params (FIN-6612)
  // Map search field to API parameter name
  if (searchField && searchText) {
    const searchValue = searchText.toLowerCase();
    switch (searchField) {
      case 'transaction-id':
        params.transactionId = searchValue;
        break;
      case 'customer-id':
        params.customerId = searchValue;
        break;
      case 'watchlist-id':
        params.watchlistId = searchValue;
        break;
      case 'watchlist-name':
        params.watchlistName = searchValue;
        break;
      case 'watchlist-category':
        params.watchlistCategorySearch = searchValue;
        break;
      default:
        break;
    }
  }

  // FIN-13644 — alertCounts below read the BE's stats branch, now opt-in.
  params.enableStats = true;

  return await axios
    .get(baseUrl, { params, cancelToken: source.token })
    .then((res) => {
      const data = {
        alerts: res.data.payload,
        offset: offset || 0,
        alertCounts: {
          all: res.data.total,
          closed: res.data.closed,
          open: res.data.open,
          underInvestigation: res.data.underInvestigation
        }
      };
      return data;
    });
}
